import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectorRef,
  HostListener,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../common.service';
import { ApiService } from '../api.service';
import {PlatformLocation} from '@angular/common';
import { ForceChangePasswordComponent } from '../force-change-password/force-change-password.component';
import {
  generateCaptchaNamespace,
  getLearnerCaptchaUrl,
  shouldAutoRefreshCaptcha
} from '../captcha.util';
import { getErrorMsg, hasFormalLoginToken } from '../login-error.util';
declare var $: any;
declare var VConsole: any;
@Component({
  selector: 'new-app-login',
  templateUrl: './new-app-login.component.html',
  styleUrls: [
    './new-app-login.component.css',
  ],
})
export class NewAppLoginComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(ForceChangePasswordComponent) forcePwdComp: ForceChangePasswordComponent;
  // 默认登录类型
  signInPhone = true;
  signInAccount = false;
  isNeed2FA = false;
  //登录按钮频繁点击控制
  phoneLoginDisabled = false;
  accountLoginDisabled = false;
  need2FAPhoneNumber = '';
  twoFactoryPhone = '';
  //反馈信息
  messageBoxOpen = false;
  tipMessage = '';
  //表单bind
  accountName = '';
  accountPwd = '';
  phoneNumber = '';
  phoneVerCode = '';
  accountNameInvalidTips = false;
  accountPwdInvalidTips = false;
  phoneNumberInvalidTips = false;
  phoneVerCodeInvalidTips = false;
  captchaInvalidTips = false;
  submitData: any = {};
  //验证码控制
  phoneVerCodeStateTxt = '获取验证码';
  phoneVerCodeRemainSeconds = '';
  clickAble = true;
  preventFrequencyTips = false;
  canSendCode = true; //验证码控制
  isOutLink = false;
  targetUrl = '';
  assetsRoute = '../../assets';
  count = 0; // 连续点击次数
  isCheckedPhone = false; //判断是否勾选
  isCheckedUser = false; //判断是否勾选
  isAccountLogin = false;
  isAICoach = false;
  need2FAData: any = {};
  isHarmonyOS = false; //是否鸿蒙系统
  /** 图形验证码（明文提交，不做 3+1） */
  captchaCode = '';
  captchaNamespace = '';
  captchaImageUrl = '';
  /** 等保预校验 challenge，正式登录 / 2FA / 多公司中间态回传 */
  protectionChallengeToken = '';
  /** 是否需要强制修改密码 */
  isNeedChangePassword = false;
  /** 待完成登录的响应（强制改密通过后继续） */
  pendingLoginRes: any = null;
  /** 强制改密流程是否已占用一条 history，用于拦截浏览器回退 */
  private forceChangeHistoryPushed = false;
  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private platformLocation: PlatformLocation,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.isHarmonyOS = this.commonService.isHarmonyOS();
    this.route.queryParams.subscribe(params => {
      this.isAICoach = params && params['isAiCoath'] ? JSON.parse(params['isAiCoath']) : this.isAICoach;
    });

    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.targetUrl = this.platformLocation['location']['href'].split('?')[1];
    if (this.platformLocation['location']['href'].split('#').length === 2){
      this.isAccountLogin = this.platformLocation['location']['href'].split('#')[1].indexOf('account') === - 1 ? false : true;
    }

    if (this.isAccountLogin){
      this.signInAccount = this.isAccountLogin;
      this.signInPhone = !this.isAccountLogin;
    }

    //清除从LMS平台缓存里的数据
    if (localStorage.getItem('source_env') == 'LMS_SCORM'){
      localStorage.removeItem('source_env');
    }

    this.refreshCaptcha();
  }

  /** 用户主动刷新 / 失效重拉：换新 namespace 并清空输入 */
  refreshCaptcha() {
    this.captchaNamespace = generateCaptchaNamespace();
    this.captchaImageUrl = getLearnerCaptchaUrl(this.captchaNamespace);
    this.captchaCode = '';
    this.captchaInvalidTips = false;
  }

  /**
   * 验图请求一次消费：成功 / 失败 / 网络错误后都换新图再提交。
   */
  maybeRefreshCaptchaAfterError(msg?) {
    if (shouldAutoRefreshCaptcha(msg)) {
      this.refreshCaptcha();
    }
  }

  clearProtectionChallenge() {
    this.protectionChallengeToken = '';
  }

  validateCaptcha() {
    if (this.isAICoach) {
      this.captchaInvalidTips = false;
      return true;
    }
    if (!this.captchaCode || !String(this.captchaCode).trim()) {
      this.captchaInvalidTips = true;
      return false;
    }
    this.captchaInvalidTips = false;
    return true;
  }

  checkMobile(mobile) {
    console.log('开始验证');
    const phoneReg = /^[1]([3-9])[0-9]{9}$/;
    const hongKongPattern = /^852[569]\d{7}$/;
    const taiwanPattern = /^8869\d{8}$/;
    if (!phoneReg.test(mobile) && !hongKongPattern.test(mobile) && !taiwanPattern.test(mobile)) {
      return false;
    }
    console.log('校验通过');
    return true;
  }
  switchLoginType() {
    //登录类型切换
    this.signInAccount = !this.signInAccount;
    this.signInPhone = !this.signInPhone;
    if (this.signInPhone) {
      this.phoneNumber = '';
      clearInterval(this.timerInterval);
      this.phoneVerCode = '';
      this.accountNameInvalidTips = false;
      this.accountPwdInvalidTips = false;
      this.phoneNumberInvalidTips = false;
      this.phoneVerCodeInvalidTips = false;
      this.canSendCode = true;
      this.phoneVerCodeRemainSeconds = '';
      this.phoneVerCodeStateTxt = '获取验证码';
      //解除按钮禁用
      this.phoneLoginDisabled = this.accountLoginDisabled = false;
    }
    this.clearProtectionChallenge();
    this.refreshCaptcha();
    this.isCheckedUser = $('#checkUser').is(':checked');
    this.isCheckedPhone = $('#checkPhone').is(':checked');
  }
  handleFormBlur() {
    console.log('blur');
    window.scroll(0, 0);
    this.commonService.initPage();
  }
  //验证账密登录
  validateAccountName() {
    if (this.accountName == '') {
      this.accountNameInvalidTips = true;
    } else {
      this.accountNameInvalidTips = false;
    }
  }
  //验证账密登录
  validateAccountPwd() {
    if (this.accountPwd == '') {
      this.accountPwdInvalidTips = true;
    } else {
      this.accountPwdInvalidTips = false;
    }
  }

  //验证手机号
  validatePhoneNumber() {
    if (this.need2FAPhoneNumber && this.signInAccount) {
      this.phoneNumber = this.need2FAPhoneNumber;
    }
    if (!this.checkMobile(this.phoneNumber)) {
      //显示错误提示
      this.phoneNumberInvalidTips = true;
    } else {
      this.phoneNumberInvalidTips = false;
    }
  }
  validatePhoneVerCode() {
    if (this.phoneVerCode == '') {
      return (this.phoneVerCodeInvalidTips = true);
    } else {
      return (this.phoneVerCodeInvalidTips = false);
    }
  }
  validateCanSend() {
    if (!this.canSendCode) {
      this.preventFrequencyTips = true;
    } else {
      this.preventFrequencyTips = false;
    }
  }

  timerInterval: any = null;
  startATimer(remainSeconds) {
    this.phoneVerCodeStateTxt = '重新获取';
    this.phoneVerCodeRemainSeconds = '(' + remainSeconds + 's)';
    this.timerInterval = setInterval(() => {
      const currentSeconds = --remainSeconds;
      this.phoneVerCodeRemainSeconds = '(' + currentSeconds + 's)';
      if (currentSeconds === 0) {
        clearInterval(this.timerInterval);
        this.canSendCode = true;
        this.phoneVerCodeRemainSeconds = '';
        this.phoneVerCodeStateTxt = '获取验证码';
      }
    }, 1000);
  }
  // 获取验证码
  getVerCode() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    //手机号验证
    this.validatePhoneNumber();
    if (this.phoneNumberInvalidTips) {
      return;
    }
    //防频繁验证
    this.validateCanSend();
    if (this.preventFrequencyTips) {
      return;
    }

    const isAccountSmsBypass = this.signInAccount && !!this.need2FAPhoneNumber;
    const needSmsCaptcha = isAccountSmsBypass && !this.isAICoach;
    if (needSmsCaptcha && !this.validateCaptcha()) {
      return;
    }

    this.canSendCode = false;
    const params = {
      phone: this.phoneNumber,
    } as any;
    if (isAccountSmsBypass) {
      params.userName = this.commonService.encrypt(this.submitData.userName);
      params.password = this.commonService.encrypt(this.submitData.password);
    }
    if (needSmsCaptcha) {
      params.captchaCode = this.captchaCode;
      params.captchaNamespace = this.captchaNamespace;
    }
    //开启倒计时:60s
    this.apiService
      .sendCode(params)
      .subscribe((data) => {
        //data为body内容
        console.log('测试获取验证码', data);
        if (needSmsCaptcha) {
          this.maybeRefreshCaptchaAfterError();
        }
        if (data.success) { //发送成功才倒计时
          this.startATimer(60);
        } else {
          this.canSendCode = true;
          this.tipMessage = data.message || data.msg;
          this.openMessageBox();
        }
      }, (error) => {
        this.canSendCode = true;
        if (needSmsCaptcha) {
          const message = getErrorMsg(error);
          this.tipMessage = message || '发送失败，请重试';
          this.openMessageBox();
          this.maybeRefreshCaptchaAfterError(message);
        }
      });
  }
  openMessageBox(){
    this.messageBoxOpen = true;
    setTimeout(() => {
      this.messageBoxOpen = false;
    }, 1500);
  }
  resetFormElement(loginType){
    if (loginType == 1){
      this.accountName = '';
      this.accountPwd = '';
    }else{
      this.phoneNumber = '';
      this.phoneVerCode = '';
    }
  }
  //
  handlePhoneOrAccountLogin() {
    if (!this.clickAble){
      return;
    }
    this.clickAble = false;
    setTimeout(() => {this.clickAble = true; }, 2000);

    // this.isOutLink = localStorage.getItem('openClass') ? true : false;
    this.isOutLink = this.platformLocation['location']['href'].indexOf('target_url=') === -1 ? false : true;
    this.submitData = {
      userName: this.accountName,
      password: this.accountPwd,
      phone: this.phoneNumber,
      verificationCode: this.phoneVerCode,
      type: 1, //默认账密类型
      companyId: '',
    };

    if (this.isAICoach){
      this.submitData['aiCoath'] = this.isAICoach;
    }

    if (this.signInAccount) {
      this.submitData.type = 1;
      this.submitData.phone = '';
      //账密
      this.validateAccountName(); //验证账户
      this.validateAccountPwd(); //密码
      if (this.accountNameInvalidTips || this.accountPwdInvalidTips) {
        return;
      }
      if (!this.validateCaptcha()) {
        return;
      }
    } else {
      this.submitData.type = 2; //修改手机验证码类型
      //手机号码
      this.validatePhoneNumber(); //验证手机号
      this.validatePhoneVerCode(); //验证验证码
      if (this.phoneNumberInvalidTips || this.phoneVerCodeInvalidTips) {
        return;
      }
      if (!this.validateCaptcha()) {
        return;
      }
    }

    if (!((this.signInAccount && this.isCheckedUser) || (this.signInPhone && this.isCheckedPhone))) {
      this.tipMessage = '请先勾选同意再登陆';
      this.openMessageBox();
      return;
    }

    // 账密标准流程：图形码预校验拿 challenge，再登录只带 challenge
    if (this.signInAccount && !this.isAICoach) {
      this.doAccountPrecheckThenLogin();
      return;
    }

    // 手机登录直连带图形码；智能陪练账密跳过图形码
    this.doLoginRequest(this.buildLoginSubmitData());
  }

  /**
   * 组装登录请求体。账密标准流只带 challenge；手机登录带明文图形码。
   */
  buildLoginSubmitData() {
    const submitData = Object.assign({}, this.submitData);
    submitData.userName = this.commonService.encrypt(this.submitData.userName);
    submitData.password = this.commonService.encrypt(this.submitData.password);

    if (submitData.type === 2) {
      submitData.userName = this.phoneNumber;
      submitData.captchaCode = this.captchaCode;
      submitData.captchaNamespace = this.captchaNamespace;
      delete submitData.protectionChallengeToken;
    } else if (this.isAICoach) {
      delete submitData.captchaCode;
      delete submitData.captchaNamespace;
      delete submitData.protectionChallengeToken;
    } else {
      submitData.protectionChallengeToken = this.protectionChallengeToken;
      delete submitData.captchaCode;
      delete submitData.captchaNamespace;
    }
    if (!submitData.companyId) {
      delete submitData.companyId;
    }
    delete submitData.token;
    delete submitData.companySelectionToken;
    return submitData;
  }

  /** 账密：validateProtectionAccount → 暂存 challenge → login */
  doAccountPrecheckThenLogin() {
    this.accountLoginDisabled = true;
    this.clearProtectionChallenge();
    this.apiService.validateProtectionAccount({
      userName: this.commonService.encrypt(this.submitData.userName),
      password: this.commonService.encrypt(this.submitData.password),
      type: 1,
      captchaCode: this.captchaCode,
      captchaNamespace: this.captchaNamespace
    }).subscribe((res) => {
      const data = this.getLoginData(res);
      const challenge = data.protectionChallengeToken;
      this.maybeRefreshCaptchaAfterError();
      if (!challenge) {
        this.accountLoginDisabled = false;
        const message = (res && res.msg) || '验证失败，请重试';
        this.tipMessage = message;
        this.openMessageBox();
        return;
      }
      this.protectionChallengeToken = challenge;
      this.doLoginRequest(this.buildLoginSubmitData());
    }, (error) => {
      this.accountLoginDisabled = false;
      let message = getErrorMsg(error);
      if (!message && error && error.status === 503) {
        message = 'Service Unavailable!';
      }
      this.tipMessage = message || '验证失败，请重试';
      this.openMessageBox();
      this.maybeRefreshCaptchaAfterError(message);
    });
  }

  doLoginRequest(submitData) {
    if (this.signInAccount) {
      this.accountLoginDisabled = true;
    } else {
      this.phoneLoginDisabled = true;
    }
    this.apiService.loginInPhoneOrAccount(submitData, { withToken: false }).subscribe((res) => {
      const data = this.getLoginData(res);
      if (data.need2FA && this.signInAccount) {
        clearInterval(this.timerInterval);
        this.need2FAData = data;
        this.isNeed2FA = true;
        this.phoneVerCode = '';
        this.accountNameInvalidTips = false;
        this.accountPwdInvalidTips = false;
        this.phoneNumberInvalidTips = false;
        this.phoneVerCodeInvalidTips = false;
        this.canSendCode = true;
        this.phoneVerCodeRemainSeconds = '';
        this.phoneVerCodeStateTxt = '获取验证码';
        //解除按钮禁用；中间态继续持有 challenge
        this.phoneLoginDisabled = this.accountLoginDisabled = false;
        this.need2FAPhoneNumber = data.twoFactorPhone;
        this.twoFactoryPhone = data.twoFactorPhone;
        this.maybeRefreshCaptchaAfterError();
        return;
      }
      // 登录接口 needChangePassword === true 时弹出强制改密
      if (this.shouldForceChangePassword(res, data)) {
        this.phoneLoginDisabled = this.accountLoginDisabled = false;
        this.openForceChangePassword(data);
        return;
      }
      if (this.submitData && Number(this.submitData.type) === 2) {
        this.maybeRefreshCaptchaAfterError();
      }
      this.handleLoginSuccess(data, submitData);
    }, error => {
      // 部分环境可能以非 2xx 返回改密标记，需同样拦截
      const errBody = error && error.error ? error.error : error;
      const errData = this.getLoginData(errBody);
      if (this.shouldForceChangePassword(errBody, errData)) {
        this.phoneLoginDisabled = this.accountLoginDisabled = false;
        this.openForceChangePassword(errData);
        return;
      }
      //登录失败
      console.log('捕获页面错误---', error);
      let message = getErrorMsg(error);
      //添加对503响应的处理
      if (!message && error.status === 503){
        message = 'Service Unavailable!';
      }
      this.tipMessage = message;
      if (this.submitData.type == 1){
        this.accountLoginDisabled = false;
      }else{
        this.phoneLoginDisabled = false;
      }
      this.resetFormElement(this.submitData.type);
      this.openMessageBox();
      this.phoneLoginDisabled = this.accountLoginDisabled = false;
      this.maybeRefreshCaptchaAfterError(message);
    });
  }

  confirm2FA() {
      this.validatePhoneNumber(); //验证手机号
      this.validatePhoneVerCode(); //验证验证码
      if (this.phoneNumberInvalidTips || this.phoneVerCodeInvalidTips) {
        return;
      }
      const submitData = {...this.submitData};
      submitData.userName = this.commonService.encrypt(this.submitData.userName);
      submitData.password = this.commonService.encrypt(this.submitData.password);
      submitData.twoFactorPhone = this.need2FAPhoneNumber;
      submitData.verificationCode = this.phoneVerCode;
      submitData.type = 1;
      // challenge 与图形码二选一，中间态只回传 challenge
      if (this.protectionChallengeToken) {
        submitData.protectionChallengeToken = this.protectionChallengeToken;
      }
      delete submitData.captchaCode;
      delete submitData.captchaNamespace;
      if (!submitData.companyId) {
        delete submitData.companyId;
      }
      delete submitData.token;
      delete submitData.companySelectionToken;
      this.apiService.loginInPhoneOrAccount(submitData, { withToken: false }).subscribe((res) => {
        const data = this.getLoginData(res);
        this.isNeed2FA = false;
        // 登录接口 needChangePassword === true 时弹出强制改密
        if (this.shouldForceChangePassword(res, data)) {
          this.phoneLoginDisabled = this.accountLoginDisabled = false;
          this.openForceChangePassword(data);
          return;
        }
        this.handleLoginSuccess(data, submitData);
      }, error => {
        const errBody = error && error.error ? error.error : error;
        const errData = this.getLoginData(errBody);
        if (this.shouldForceChangePassword(errBody, errData)) {
          this.phoneLoginDisabled = this.accountLoginDisabled = false;
          this.openForceChangePassword(errData);
          return;
        }
        //登录失败
        console.log('捕获页面错误---', error);
        let message = getErrorMsg(error);
        //添加对503响应的处理
        if (!message && error.status === 503){
          message = 'Service Unavailable!';
        }
        this.tipMessage = message;
        this.resetFormElement(this.submitData.type);
        this.openMessageBox();
        this.phoneLoginDisabled = this.accountLoginDisabled = false;
      });
  }

  /**
   * 兼容 { success, data } 与扁平返回；保留顶层 needChangePassword 等标记
   */
  getLoginData(res) {
    if (!res) {
      return {};
    }
    let loginData = res;
    if (res.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
      if (
        Object.prototype.hasOwnProperty.call(res.data, 'needChangePassword') ||
        Object.prototype.hasOwnProperty.call(res.data, 'token') ||
        Object.prototype.hasOwnProperty.call(res.data, 'need2FA') ||
        Object.prototype.hasOwnProperty.call(res.data, 'userId') ||
        Object.prototype.hasOwnProperty.call(res.data, 'protectionChallengeToken') ||
        Object.prototype.hasOwnProperty.call(res.data, 'companySelectionToken')
      ) {
        loginData = Object.assign({}, res.data);
      }
    }
    // 顶层改密标记可能与 data 并存，解包后需合并回去
    if (res.needChangePassword === true) {
      loginData.needChangePassword = true;
    }
    if (res.weakPasswordReasonCode) {
      loginData.weakPasswordReasonCode = res.weakPasswordReasonCode;
    }
    if (res.weakPasswordReasonText) {
      loginData.weakPasswordReasonText = res.weakPasswordReasonText;
    }
    if (res.token && !loginData.token) {
      loginData.token = res.token;
    }
    if (res.protectionChallengeToken && !loginData.protectionChallengeToken) {
      loginData.protectionChallengeToken = res.protectionChallengeToken;
    }
    if (res.companySelectionToken && !loginData.companySelectionToken) {
      loginData.companySelectionToken = res.companySelectionToken;
    }
    if (res.companyList && !loginData.companyList) {
      loginData.companyList = res.companyList;
    }
    return loginData;
  }

  shouldForceChangePassword(res, loginData?) {
    const data = loginData || res || {};
    return !!(
      (res && res.needChangePassword === true) ||
      data.needChangePassword === true
    );
  }

  openForceChangePassword(loginData) {
    this.pendingLoginRes = loginData ? JSON.parse(JSON.stringify(loginData)) : {};
    // 改密接口通常需要登录态，先落 token
    if (loginData && loginData.token) {
      localStorage.setItem('transtalen-token', loginData.token);
      if (loginData.userIdEncoder) {
        localStorage.setItem('transtalenuserid', loginData.userIdEncoder);
      }
      this.apiService.setHeaders();
    }
    this.isNeedChangePassword = true;
    // 占用一条历史记录：回退时先取消未完成改密，避免带着临时 token 直接进入系统
    try {
      history.pushState({ forceChangePassword: true }, document.title, location.href);
      this.forceChangeHistoryPushed = true;
    } catch (e) {
      this.forceChangeHistoryPushed = false;
    }
    this.cdr.detectChanges();
  }

  /**
   * 浏览器回退：强制改密未完成时清理临时登录态，回到登录表单
   */
  @HostListener('window:popstate', ['$event'])
  onPopState() {
    if (this.isNeedChangePassword) {
      this.cancelForceChangePassword();
    }
  }

  /**
   * 取消强制改密（回退/离开页面）：清除临时 token，避免绕过改密
   */
  cancelForceChangePassword() {
    this.isNeedChangePassword = false;
    this.pendingLoginRes = null;
    this.forceChangeHistoryPushed = false;
    localStorage.removeItem('transtalen-token');
    localStorage.removeItem('transtalenuserid');
    this.apiService.setHeaders();
    this.clearProtectionChallenge();
    this.refreshCaptcha();
    this.phoneLoginDisabled = this.accountLoginDisabled = false;
    this.cdr.detectChanges();
  }

  /** 关闭改密页，回到登录页，不完成登录 */
  onForceChangePasswordClose() {
    const pushed = this.forceChangeHistoryPushed;
    this.cancelForceChangePassword();
    if (pushed) {
      history.back();
    }
  }

  /**
   * 强制改密确认后：updatePassword 成功即可进入。
   * 产品约定 needChangePassword=true 时首次登录已视为登录成功，无需再调 login。
   */
  onForceChangePasswordSuccess({ plainNewPassword, currentPassword, newPassword }) {
    this.accountPwd = plainNewPassword || this.accountPwd;
    this.submitData.password = this.accountPwd;

    // 文档约定：updatePassword 仅传 currentPassword、newPassword（均已加密）
    this.apiService.updatePassword({
      currentPassword,
      newPassword
    }).subscribe(() => {
      const loginRes = Object.assign({}, this.pendingLoginRes || {});
      loginRes.needChangePassword = false;
      // 先结束强制改密态，避免后续跳转/回退被当成“未完成改密”清掉 token
      this.isNeedChangePassword = false;
      this.pendingLoginRes = null;
      this.forceChangeHistoryPushed = false;

      const submitData = Object.assign({}, this.submitData);
      submitData.userName = this.commonService.encrypt(this.submitData.userName);
      submitData.password = this.commonService.encrypt(this.submitData.password);
      this.handleLoginSuccess(loginRes, submitData);
    }, error => {
      let message = error && error.error && error.error.msg;
      if (!message && error && error.status === 503) {
        message = 'Service Unavailable!';
      }
      this.tipMessage = message || '修改密码失败，请稍后重试';
      this.openMessageBox();
      if (this.forcePwdComp) {
        this.forcePwdComp.resetSubmitting();
      }
    });
  }

  ngOnDestroy() {
    // 组件销毁时若仍处于强制改密，清理临时登录态，防止绕过
    if (this.isNeedChangePassword) {
      localStorage.removeItem('transtalen-token');
      localStorage.removeItem('transtalenuserid');
      this.apiService.setHeaders();
      this.clearProtectionChallenge();
      this.isNeedChangePassword = false;
      this.pendingLoginRes = null;
      this.forceChangeHistoryPushed = false;
    }
  }

  persistLoginCredentialsFromForm() {
    const account = this.submitData.type === 2
      ? (this.phoneNumber || this.submitData.phone || '')
      : (this.accountName || this.submitData.userName || '');
    const password = this.accountPwd || this.submitData.password || '';
    this.commonService.persistLoginCredentials(account, password, this.submitData.type);
  }

  /** 多公司中间态写入 loginData：只存短票 + 公司列表，禁止写入正式 token / 图形码 */
  prepareLoginDataForCompanySelect() {
    const stored = Object.assign({}, this.submitData);
    stored.userName = this.submitData.type === 2
      ? (this.phoneNumber || this.submitData.phone || '')
      : (this.accountName || this.submitData.userName || '');
    stored.password = this.commonService.xorEncrypt(
      this.accountPwd || this.submitData.password || '',
      this.commonService.xorKey
    );
    delete stored.captchaCode;
    delete stored.captchaNamespace;
    delete stored.verificationCode;
    delete stored.token;
    delete stored.companyId;
    if (this.protectionChallengeToken) {
      stored.protectionChallengeToken = this.protectionChallengeToken;
    }
    return stored;
  }

  persistMultiCompanySelectState(data) {
    const stored = this.prepareLoginDataForCompanySelect();
    stored.companyList = data && data.companyList ? data.companyList : [];
    stored.companySelectionToken = data && data.companySelectionToken ? data.companySelectionToken : '';
    stored.phone = this.phoneNumber || stored.phone || stored.userName;
    localStorage.setItem('loginData', JSON.stringify(stored));
    localStorage.removeItem('transtalen-token');
    this.apiService.setHeaders();
  }

  handleLoginSuccess(data, submitData) {
    //解除按钮禁用
    this.phoneLoginDisabled = this.accountLoginDisabled = false;
    this.persistLoginCredentialsFromForm();
    //删掉登录信息记录
    localStorage.removeItem('loginData');
    console.log(data, '登录接口返回------------------------------------');
    const loggedIn = hasFormalLoginToken(data);
    const hasManyCompany = this.hasMultiValidCompany(data);
    if (loggedIn){
      localStorage.setItem('transtalen-token', data.token);
      if (data.userIdEncoder) {
        localStorage.setItem('transtalenuserid', data.userIdEncoder);
      }
      this.apiService.setHeaders(); //header设置
      // 最终拿到正式登录态后丢弃 challenge
      this.clearProtectionChallenge();
    }
    if (data.redirectUrl){
      this.clearProtectionChallenge();
      this.platformLocation['location']['href'] = data.redirectUrl;
    }else{
      if (this.isOutLink){
        if (!loggedIn && hasManyCompany){
          this.persistMultiCompanySelectState(data);
          this.router.navigate(['/course-select'], { queryParams: {
              notSelectCompany: 'yes'
            }});
          return;
        }
        if (data.status === 0 ){
          this.clearProtectionChallenge();
          this.router.navigate(['/learning-map']);
          localStorage.removeItem('targetUrl');
        }else{
          localStorage.setItem('openClass', '1');
          localStorage.setItem('targetUrl', this.targetUrl);
          this.clearProtectionChallenge();
          localStorage.setItem('userId', data.userId);
          //增加一个条件，如果当前target_url里包含leadershipcoach这个字符串，则认为是要直接跳转到导师的，将token替换进去之后跳到target_url
          if (this.platformLocation['location']['href'].indexOf('leadershipcoach') !== -1) {
            const targetUrl = this.commonService.extractTargetUrlAndAddToken(window.location.href, data.token);
            console.log('targetUrl', targetUrl);
            window.location.href = targetUrl;
          } else {
            if (this.commonService.getQueryString('isIntelligent')){
              //这里不能直接跳到智能陪练列表页，因为target_url里没有token,需要将token字段进行替换之后再跳转
              console.log('target_url', decodeURIComponent(this.commonService.getQueryString('target_url')));
              const url = new URL(decodeURIComponent(this.commonService.getQueryString('target_url')));
              const newUrl = url.toString();
              window.location.href =  decodeURIComponent(newUrl);
            }else{
              this.platformLocation['location']['href'] = this.platformLocation['location']['origin'] + '/ddilearner/v1/user/authorize?token=' + data.token + '&' + this.targetUrl;
            }
          }
        }
      }else{
        localStorage.removeItem('openClass');
        localStorage.removeItem('targetUrl');
        localStorage.removeItem('exerciseGroup');
        localStorage.removeItem('pdfList');
        localStorage.removeItem('uploadList');
        localStorage.removeItem('uploadId');
        localStorage.removeItem('canSave');
        if (loggedIn){
          this.clearProtectionChallenge();
          this.router.navigate(['/learning-map']);
        }else if (hasManyCompany){
          this.persistMultiCompanySelectState(data);
          this.router.navigate(['/course-select'], { queryParams: {
              notSelectCompany: 'yes'
            }});
        }
      }
    }
  }

  hasMultiValidCompany(data) {
    const list = data && Array.isArray(data.companyList) ? data.companyList : [];
    return list.filter(item => item.state === 1).length > 1;
  }

  showVersion(){
    this.count++;
    if (this.count > 10){
      const vConsole = new VConsole();
      this.count = 0;
    }
  }

  check(){
    this.isCheckedUser = $('#checkUser').is(':checked');
    this.isCheckedPhone = $('#checkPhone').is(':checked');
  }

  closePopover() {
    clearInterval(this.timerInterval);
    this.isNeed2FA = false;
    if (this.need2FAPhoneNumber) {
      this.need2FAPhoneNumber = '';
      this.twoFactoryPhone = '';
    }
    clearInterval(this.timerInterval);
    this.phoneVerCode = '';
    this.accountNameInvalidTips = false;
    this.accountPwdInvalidTips = false;
    this.phoneNumberInvalidTips = false;
    this.phoneVerCodeInvalidTips = false;
    this.canSendCode = true;
    this.phoneVerCodeRemainSeconds = '';
    this.phoneVerCodeStateTxt = '获取验证码';
    //解除按钮禁用
    this.phoneLoginDisabled = this.accountLoginDisabled = false;
  }

  ngAfterViewInit() {
    this.commonService.initPage();
  }


}



// WEBPACK FOOTER //
// ./src/app/new-app-login/new-app-login.component.ts